import React from 'react';

interface RoleBadgeProps {
  role: string | null;
}

const getRoleStyles = (role: string | null): { bgColor: string; textColor: string } => {
  if (!role) {
    // Default style for null roles, though the component returns null.
    return { bgColor: 'bg-brand-light-purple/20', textColor: 'text-brand-purple' };
  }

  const lowerCaseRole = role.toLowerCase();

  if (lowerCaseRole.includes('nurse')) {
    return { bgColor: 'bg-brand-orange/20', textColor: 'text-brand-orange' };
  }
  if (lowerCaseRole.includes('physio')) { // Handles "Physiotherapy", "Physiotherapist", etc.
    return { bgColor: 'bg-green-100', textColor: 'text-green-800' };
  }
  // Default for 'caregiver' and any other roles
  return { bgColor: 'bg-brand-light-purple/20', textColor: 'text-brand-purple' };
};


const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  if (!role) {
    return null;
  }

  const { bgColor, textColor } = getRoleStyles(role);

  return (
    <span className={`inline-block px-3 py-1 text-sm font-medium rounded-full ${bgColor} ${textColor}`}>
      {role.charAt(0).toUpperCase() + role.slice(1)}
    </span>
  );
};

export default RoleBadge;
